export default __webpack_public_path__ + "static/media/galerie7.ae80169f.jpeg";